import { API } from 'aws-amplify';

const chargeUser = async data => {
  const result = await API.post('agentbuzz', 'billing', {
    body: createChargeData(data),
  });
  return result;
};

const createChargeData = data => {
  return data.map(c => {
    return {
      amount: c.amount * 100, // must be in cents
      description: c.description,
    };
  });
};
export default chargeUser;



// WEBPACK FOOTER //
// ./src/services/billing/chargeUser.js